<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="far fa-building" class="q-mb-sm" /> {{ $t('branch') }}
		</div>
		<div class="row gutter-sm">
			<div class="col-xs-12 col-sm-12">
				<q-chips-input
					v-model="companies_label"
					ref="companies_label"
					:float-label="$t('headquarter')"
					:error="$v.companies_label.$error"
					@input="$v.companies_label.$touch"
					@remove="removeHeadquarter"
					:disable="$route.params.id_company ? true : false"
					filter
					autofocus-filter
				>
					<q-autocomplete
						@search="fetchHeadquarters"
						@selected="selectHeadquarter"
						:min-characters="1"
						:max-results="100"
					/>
				</q-chips-input>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-field :count="140">
					<q-input
						v-model="name"
						ref="name"
						:float-label="$t('name')"
						:error="$v.name.$error"
						@input="$v.name.$touch"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-field :count="140">
					<q-input
						v-model="fantasy"
						ref="fantasy"
						:float-label="$t('fantasy_name')"
						:error="$v.fantasy.$error"
						@input="$v.fantasy.$touch"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input
					v-model="document"
					:color="document_error ? 'danger' : 'primary'"
					ref="document"
					:float-label="$t('store_document')"
					@blur="documentUnique()"
				/>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input
					v-model="register"
					ref="register"
					:float-label="$t('register_number')"
					@blur="registerUnique()"
				/>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="register_error && id_branch">
				<q-btn
					color="secondary"
					size="small"
					:label="$t('edit_branch_found')"
					icon="fal fa-edit"
					@click="openBranch()"
				/>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="document_error && id_branch">
				<q-btn
					color="secondary"
					size="small"
					:label="$t('edit_branch_found')"
					icon="fal fa-edit"
					@click="openBranch()"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-select
					filter
					autofocus-filter
					v-model="branch_type"
					:options="branch_types"
					:float-label="$t('branch_type')"
					clearable
				/>
			</div>

			<!-- VERIFICAR SE SERÁ OBRIGATÓRIO - CAMPO EXCLUSIVO GM -->
			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-12">
				<q-select
					v-model="branch_size_type"
					:options="branch_size_types"
					:float-label="$t('branch_size_types')"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-select
					filter
					autofocus-filter
					v-model="regional"
					:options="regionals"
					:float-label="$t('regional')"
					clearable
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-select
					filter
					autofocus-filter
					v-model="country"
					ref="country"
					:options="countries"
					:float-label="$t('country')"
					:error="$v.country.$error"
					@input="$v.country.$touch"
				/>
			</div>

			<div v-if="keyGooogleMaps" class="col-xs-12 col-sm-12">
				<q-field
					:error="show_maps_alert"
					:error-label="
						$t(
							'not_found_check_that_the_search_is_spelled_correctly_and_try_to_add_a_street_address_and_the_number_of_valid_addresses'
						)
					"
				>
					<q-input
						v-model="address"
						ref="address"
						:float-label="$t('address')"
						autocomplete="new-password"
						:error="$v.address.$error"
						@input="$v.address.$touch"
						:placeholder="$t('search_by_name_and_street_number')"
					>
						<q-autocomplete
							@search="getAddressGoogleMaps"
							:min-characters="3"
							@selected="selectedAddressGoogleMaps"
							separator
						/>
					</q-input>
				</q-field>
			</div>

			<div v-else class="col-xs-12 col-sm-12">
				<q-input
					v-model="address"
					:float-label="$t('address')"
					autocomplete="new-password"
					:error="$v.address.$error"
					@input="$v.address.$touch"
				>
					<q-autocomplete
						@search="getAddress"
						:min-characters="3"
						@selected="selectedAddress"
						separator
					/>
				</q-input>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input v-model="number" :float-label="$t('number')" ref="number" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input v-model="complement" :float-label="$t('complement')" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input v-model="neighborhood" :float-label="$t('neighborhood')" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input v-model="postal_code" :float-label="$t('postal_code')" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input
					v-model="city"
					ref="city"
					:float-label="$t('city')"
					:error="$v.city.$error"
					@input="$v.city.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input
					v-model="state"
					ref="state"
					:float-label="$t('state')"
					:error="$v.state.$error"
					@input="$v.state.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input v-model="lat" type="number" :float-label="$t('latitude')" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input v-model="long" type="number" :float-label="$t('longitude')" />
			</div>

			<div class="col-xs-12 col-sm-4 flex  items-end justify-center">
				<q-btn
					@click="showMap()"
					:disabled="disabledButton"
					class="full-width"
					color="primary"
					icon="map"
					label="Ver no mapa"
				/>
			</div>

			<!-- Chevrolet custom fields -->
			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-4">
				<q-input v-model="regional_name" type="text" :float-label="$t('region')" />
			</div>

			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-4">
				<q-input v-model="area_email" type="email" :float-label="$t('area_email')" />
			</div>

			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-4">
				<q-input v-model="phone_number" type="tel" :float-label="$t('phone_number')" />
			</div>

			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-4">
				<q-input
					v-model="operational_area"
					type="text"
					:float-label="$t('operational_area')"
				/>
			</div>

			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-4">
				<q-input v-model="division" type="text" :float-label="$t('division')" />
			</div>

			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-4">
				<q-input v-model="district" type="text" :float-label="$t('district')" />
			</div>

			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-6">
				<q-datetime
					v-model="opened_date"
					type="datetime"
					:float-label="$t('opened_date')"
					format="DD/MM/YYYY"
				/>
			</div>

			<div v-if="current_client === 'chevrolet'" class="col-xs-12 col-sm-6">
				<q-datetime
					v-model="closed_date"
					type="datetime"
					:float-label="$t('closed_date')"
					format="DD/MM/YYYY"
				/>
			</div>
			<!-- END of Chevrolet custom fields -->

			<div class="col-xs-12 col-sm-12">
				<q-select
					filter
					autofocus-filter
					multiple
					v-model="client"
					ref="client"
					:options="clients"
					chips
					:float-label="$t('clients')"
					:error="$v.client.$error"
					@input="$v.client.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-12 q-mt-sm">
				<p class="caption">{{ $t('areas') }}</p>
				<q-checkbox
					class="q-mb-xs"
					:disable="!client.length"
					v-model="all_areas"
					:val="true"
					:label="$t('select_all_areas')"
					@input="checkAllAreas()"
				/>
				<select-multiple
					ref="area"
					label="areas"
					:filters="area"
					:options="filtered_areas"
					@on_value="area = $event"
					:error="$v.area.$error"
					@input="$v.area.$touch"
				/>
			</div>

			<div class="col-12">
				<q-chips-input
					v-model="managers_general_list"
					:float-label="$t('managers_general')"
					@remove="removeOwnerGeneral"
					v-if="isVivara"
				>
					<q-autocomplete
						@search="searchOwnerGeneral"
						@selected="selectOwnerGeneral"
						:min-characters="3"
						:value-field="(v) => `${v.full_name} - ${v.email}`"
					/>
				</q-chips-input>
			</div>

			<div class="col-12">
				<q-chips-input
					v-model="managers_regional_list"
					:float-label="$t('managers_regional')"
					@remove="removeOwnerRegional"
					v-if="isVivara"
				>
					<q-autocomplete
						@search="searchOwnerRegional"
						@selected="selectOwnerRegional"
						:min-characters="3"
						:value-field="(v) => `${v.full_name} - ${v.email}`"
					/>
				</q-chips-input>
			</div>

			<div class="col-12">
				<q-chips-input
					v-model="managers_list"
					:float-label="$t('managers')"
					@remove="removeOwner"
				>
					<q-autocomplete
						@search="searchOwner"
						@selected="selectOwner"
						:min-characters="3"
						:value-field="(v) => `${v.full_name} - ${v.email}`"
					/>
				</q-chips-input>
			</div>

			<div class="col-xs-12 col-sm-12">
				<p class="caption">{{ $t('status') }}</p>
				<q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
			</div>
		</div>
		<div class="q-display-1 q-mt-lg text-secondary">
			<q-icon name="far fa-users" class="q-mb-sm" /> {{ $t('users') }}
		</div>
		<users :id="id" v-if="id" />

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="backBranch()"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import { debounce, date } from 'quasar'
const { formatDate } = date
import { OpenStreetMapProvider } from 'leaflet-geosearch'
import Users from 'components/admin/organization/Users.vue'
import SelectMultiple from 'components/utils/SelectMultiple'
const provider = new OpenStreetMapProvider({
	params: {
		addressdetails: '1',
	},
})

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'admin', 'organization', 'users'] },

	components: {
		users: Users,
		'select-multiple': SelectMultiple,
	},

	data() {
		return {
			id: '',
			name: '',
			fantasy: '',
			register: null,
			document: null,
			branch_type: null,
			address: '',
			number: '',
			complement: '',
			neighborhood: '',
			postal_code: '',
			lat: '',
			long: '',
			city: '',
			state: '',
			country: '',
			status: 1,
			statuses: [
				{ label: this.$t('active'), value: 1 },
				{ label: this.$t('inactive'), value: 2 },
				{ label: this.$t('pending'), value: 4 },
			],
			all_profiles: false,
			company: '',
			area: [],
			companies: [],
			companies_label: [],
			document_error: false,
			register_error: false,
			regional_name: null,
			phone_number: null,
			area_email: null,
			operational_area: null,
			division: null,
			district: null,
			opened_date: null,
			closed_date: null,
			regional: null,
			regionals: [],
			clients: [],
			client: [],
			countries: [],
			country: null,
			id_branch: '',
			origin: '',
			option_address: [],
			show_maps_alert: false,
			managers_general_list: [],
			managers_general: [],
			managers_regional_list: [],
			managers_regional: [],
			managers_list: [],
			managers: [],
			current_client: '',
			all_areas: false,
			// Chevrolet only
			branch_size_type: 1,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			branch_types: 'registration_lists/branch_types',
			user_clients: 'common/user_clients',
			clients_params: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			areas: 'registration_lists/areas',
			branch_size_types: 'registration_lists/branch_size_types',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else if (this.status == 2) return 'negative'
			else if (this.status == 4) return 'warning'
		},

		addressRequired() {
			if (this.address || this.city || this.state || this.country || this.lat || this.long)
				return true
			else return false
		},

		disabledButton() {
			if (this.lat == null || this.lat == '' || this.long == null || this.long == '')
				return 'disabled'
		},

		keyGooogleMaps() {
			const clientParams = this.clients_params.find((obj) => obj.id === this.id_user_client_selected)
			if (clientParams.use_google_maps && process.env.KEY_GOOGLE_API) {
				return process.env.KEY_GOOGLE_API
			} else {
				return false
			}
			
		},

		filtered_areas() {
			let areas = []
			let selected_clients = this.user_clients.filter((e) => this.client.includes(e.id))
			selected_clients.forEach((client) => {
				client.client_areas.forEach((area) => {
					areas.push(area)
				})
			})
			return areas
		},

		isVivara() {
			if (process.env.PROJECT_FOLDER === 'mundovivara') return true
			else return false
		},
	},

	methods: {
		fetchLists() {
			this.$q.loading.show()

			this.$axios
				.get('/admin_companies/branch_regional/', this.getHeader)
				.then((regionals) => {
					regionals.data.forEach((regional) => {
						this.regionals.push({ value: regional.id, label: regional.name })
					})

					if (this.id != 0) this.fetchData()
					else this.$q.loading.hide()
				})

				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		fetchData() {
			this.$axios
				.get(`/admin_companies/branches/${this.id}/`, this.getHeader)
				.then((response) => {
					this.name = response.data.name
					this.fantasy = response.data.fantasy
					this.document = response.data.document
					this.branch_type = response.data.branch_type
					this.company = response.data.company
					this.regional = response.data.regional
					this.status = response.data.status
					this.client = response.data.clients
					this.register = response.data.register
					this.area = response.data.areas
					this.regional_name = response.data.regional_name
					this.phone_number = response.data.phone
					this.area_email = response.data.email
					this.operational_area = response.data.operational_area
					this.division = response.data.division
					this.district = response.data.district
					this.opened_date = response.data.opened_date
					this.closed_date = response.data.closed_date
					this.branch_size_type = response.data.branch_size_type
						? response.data.branch_size_type
						: null

					if (response.data.address) {
						this.address = response.data.address.address
						this.postal_code = response.data.address.postal_code
						this.city = response.data.address.city
						this.state = response.data.address.state
						this.lat = response.data.address.lat
						this.long = response.data.address.long
						this.neighborhood = response.data.address.neighborhood
						this.number = response.data.address.number
						this.complement = response.data.address.complement
						this.country = response.data.address.country
					}

					if (response.data.managers_general) {
						response.data.managers_general.forEach((owner) => {
							this.managers_general_list.push(`${owner.full_name} - ${owner.email}`)
							this.managers_general.push(owner.id)
						})
					}

					if (response.data.managers_regional) {
						response.data.managers_regional.forEach((owner) => {
							this.managers_regional_list.push(`${owner.full_name} - ${owner.email}`)
							this.managers_regional.push(owner.id)
						})
					}

					response.data.managers.forEach((owner) => {
						this.managers_list.push(`${owner.full_name} - ${owner.email}`)
						this.managers.push(owner.id)
					})

					if (response.data.branch_company) {
						this.companies_label.push(response.data.branch_company.name)
					}

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let address = {
					address: this.address,
					number: this.number,
					complement: this.complement,
					postal_code: this.postal_code,
					city: this.city,
					state: this.state,
					neighborhood: this.neighborhood,
					lat: this.lat,
					long: this.long,
					country: this.country,
				}

				let fd = {
					address: address,
					branch_type: this.branch_type,
					company: this.company,
					regional: this.regional,
					document: this.document,
					fantasy: this.fantasy,
					name: this.name,
					status: this.status,
					clients: this.client,
					register: this.register,
					regional_name: this.regional_name,
					phone: this.phone_number,
					email: this.area_email,
					operational_area: this.operational_area,
					division: this.division,
					district: this.district,
					opened_date: date.formatDate(this.opened_date, 'YYYY-MM-DD'),
					closed_date: date.formatDate(this.closed_date, 'YYYY-MM-DD'),
				}

				if (this.current_client === 'chevrolet') {
					fd.branch_size_type = this.branch_size_type
				}

				if (this.managers_general.length > 0) fd.managers_general = this.managers_general
				if (this.managers_regional.length > 0) fd.managers_regional = this.managers_regional
				if (this.managers.length > 0) fd.managers = this.managers

				if (this.area.length > 0) fd.areas = this.area

				if (this.id != 0) {
					this.$axios
						.put(`/admin_companies/branches/${this.id}/`, fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('branch_save_success'),
								type: 'positive',
								icon: 'fal fa-save',
								position: 'bottom',
							})
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else {
					this.$axios
						.post(`/admin_companies/branches/`, fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('branch_save_success'),
								type: 'positive',
								icon: 'fal fa-save',
								position: 'bottom',
							})

							this.id = response.data.id
							if (this.origin === 'headquarter')
								this.$router.push({
									name: 'admin_branch',
									params: { id: response.data.id, id_company: this.company },
								})
							else
								this.$router.push({
									name: 'admin_branch',
									params: { id: response.data.id },
								})
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$formInputErrorFocus(this.$v, this.$refs)
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		fetchBranchTypes() {
			return this.$axios.get('/admin_companies/branch_types/', this.getHeader)
		},

		fetchHeadquarters(terms, done) {
			this.$axios
				.get(`/admin_companies/companies/get_companies/?search=${terms}`, this.getHeader)
				.then((response) => {
					let headquarters = []

					response.data.forEach((element) => {
						headquarters.push({
							value: element.id,
							label: `${element.name} / ${this.$t(element.company_type_label)} ${
								element.document && element.register
									? `${element.document} - ${element.register}`
									: element.document
									? element.document
									: element.register
									? element.register
									: ''
							}`,
							address: element.address,
							client: element.client,
							company_type: element.company_type,
							company_type_label: element.company_type_label,
							created_date: element.created_date,
							document: element.document,
							fantasy: element.fantasy,
							id: element.id,
							name: element.name,
							qty_branches: element.qty_branches,
							status: element.status,
							updated_date: element.updated_date,
						})
					})

					done(headquarters)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectHeadquarter(item) {
			this.company = item.id
			let obj = this.companies.find((obj) => {
				return obj.id === item.id
			})
			if (!obj) {
				this.companies.push(item)
			}

			this.companies_label = []
			this.companies.forEach((element) => {
				this.companies_label.push(element.name)
			})
		},

		async autoSelectHeadquarter(document) {
			try {
				let response = await this.$axios.get(
					`/admin_companies/companies/get_companies/?search=${document}`,
					this.getHeader
				)
				let headquarters = []

				response.data.forEach((element) => {
					headquarters.push({
						value: element.id,
						label: `${element.name} / ${this.$t(element.company_type_label)} ${
							element.document && element.register
								? `${element.document} - ${element.register}`
								: element.document
								? element.document
								: element.register
								? element.register
								: ''
						}`,
						address: element.address,
						client: element.client,
						company_type: element.company_type,
						company_type_label: element.company_type_label,
						created_date: element.created_date,
						document: element.document,
						fantasy: element.fantasy,
						id: element.id,
						name: element.name,
						qty_branches: element.qty_branches,
						status: element.status,
						updated_date: element.updated_date,
					})
				})

				if (headquarters.length === 1) {
					this.selectHeadquarter(headquarters[0])
				} else {
					this.$router.push({ name: 'admin_branches' })
				}
			} catch (error) {
				console.log(error)
			}
		},

		removeHeadquarter({ index, value }) {
			this.companies.splice(index, 1)
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getAddress(terms, done) {
			provider.search({ query: terms }).then((result) => {
				done(result)
			})
		},

		selectedAddress(item) {
			this.$nextTick(() => (this.address = item.raw.address.road))
			this.postal_code = item.raw.address.postcode
			this.city = item.raw.address.city
			this.state = item.raw.address.state
			this.lat = item.raw.lat
			this.long = item.raw.lon

			if (item.raw.address.neighbourhood) {
				this.neighborhood = item.raw.address.neighbourhood
			} else if (item.raw.address.suburb) {
				this.neighborhood = item.raw.address.suburb
			} else if (item.raw.address.city_district) {
				this.neighborhood = item.raw.address.city_district
			}

			this.$nextTick(() => this.$refs.number.$el.focus())
		},

		getAddressGoogleMaps(terms, done) {
			this.$axios
				.get(
					`https://maps.googleapis.com/maps/api/geocode/json?address=${terms}&key=${
						this.keyGooogleMaps
					}`
				)
				.then((response) => {
					if (response.data.results.length > 0) {
						this.option_address = response.data.results
						let teste = response.data.results.map((e) => ({
							label: e.formatted_address,
							value: e.formatted_address,
							place_id: e.place_id,
						}))
						done(teste)
					} else {
						this.show_maps_alert = true
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},

		selectedAddressGoogleMaps(item) {
			this.show_maps_alert = false
			this.address = ''
			this.number = ''
			this.neighborhood = ''
			this.postal_code = ''
			this.city = ''
			this.state = ''
			this.option_address.map((x) => {
				if (x.place_id === item.place_id) {
					this.lat = x.geometry.location.lat
					this.long = x.geometry.location.lng
					x.address_components.map((e) => {
						switch (e.types[0]) {
							case 'route':
								this.address = e.long_name
								break
							case 'street_number':
								this.number = e.long_name
								break
							case 'political':
							case 'administrative_area_level_4':
								this.neighborhood = e.long_name
								break
							case 'postal_code':
								this.postal_code = e.long_name
								break
							case 'administrative_area_level_2':
								this.city = e.long_name
								break
							case 'administrative_area_level_1':
								this.state = e.long_name
								break
						}
					})
				}
			})
		},

		backBranch() {
			if (this.$route.params.id_company) {
				this.$router.push({
					name: 'admin_headquarter',
					params: { id: this.$route.params.id_company },
				})
			} else {
				this.$router.push({ name: 'admin_branches' })
			}
		},

		documentUnique() {
			if (this.document) {
				let fd = new FormData()
				fd.append('document', this.document)
				fd.append('id_branch', this.id)

				this.$axios
					.post(`/admin_companies/branches/check_document_existance/`, fd, this.getHeader)
					.then((response) => {
						if (response.data.exists) {
							this.document_error = true
							this.id_branch = response.data.id_branch
						} else this.document_error = false
					})
					.catch((e) => {
						console.log(e)
					})
			} else this.document_error = false
		},

		registerUnique() {
			if (this.register) {
				let fd = new FormData()
				fd.append('register', this.register)
				fd.append('id_branch', this.id)

				this.$axios
					.post(`/admin_companies/branches/check_register_existance/`, fd, this.getHeader)
					.then((response) => {
						if (response.data.exists) {
							this.register_error = true
							this.id_branch = response.data.id_branch
						} else this.register_error = false
					})
					.catch((e) => {
						console.log(e)
					})
			} else this.register_error = false
		},

		getCountryList() {
			this.countries = []

			if (this.user_clients) {
				let obj = this.user_clients.find((obj) => {
					return obj.id == this.id_user_client_selected
				})

				if (obj) {
					obj.countries.forEach((country) => {
						this.countries.push({
							label: country.name,
							value: country.id,
						})
					})
				}
			}
		},

		showMap() {
			if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
				cordova.InAppBrowser.open(
					`http://maps.google.com/?q=${this.lat},${this.long}`,
					'_system',
					'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no'
				)
			} else {
				window.open(`http://maps.google.com/?q=${this.lat},${this.long}`, '_blank')
			}
		},

		openBranch() {
			this.$router.push({ name: 'admin_branch', params: { id: this.id_branch } })
			this.$v.$reset()
			this.document_error = false
			this.register_error = false
			this.id_branch = ''
			this.id = this.$route.params.id
			if (this.id != 0) this.fetchData()
		},

		searchOwnerGeneral(terms, done) {
			this.$axios
				.get(`/accounts/get_owners/?search=${terms}`, this.getHeader)
				.then((response) => {
					let users = []

					response.data.forEach((element) => {
						users.push({
							value: element.id,
							label: `${element.full_name} - ${element.email}`,
							full_name: element.full_name,
							email: element.email,
							id: element.id,
						})
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectOwnerGeneral(item, keyboard) {
			if (!keyboard) this.managers_general.push(item.id)
		},

		removeOwnerGeneral({ index, value }) {
			this.managers_general.splice(index, 1)
		},

		searchOwnerRegional(terms, done) {
			this.$axios
				.get(`/accounts/get_owners/?search=${terms}`, this.getHeader)
				.then((response) => {
					let users = []

					response.data.forEach((element) => {
						users.push({
							value: element.id,
							label: `${element.full_name} - ${element.email}`,
							full_name: element.full_name,
							email: element.email,
							id: element.id,
						})
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectOwnerRegional(item, keyboard) {
			if (!keyboard) this.managers_regional.push(item.id)
		},

		removeOwnerRegional({ index, value }) {
			this.managers_regional.splice(index, 1)
		},

		searchOwner(terms, done) {
			this.$axios
				.get(`/accounts/get_owners/?search=${terms}`, this.getHeader)
				.then((response) => {
					let users = []

					response.data.forEach((element) => {
						users.push({
							value: element.id,
							label: `${element.full_name} - ${element.email}`,
							full_name: element.full_name,
							email: element.email,
							id: element.id,
						})
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectOwner(item, keyboard) {
			if (!keyboard) this.managers.push(item.id)
		},

		removeOwner({ index, value }) {
			this.managers.splice(index, 1)
		},

		checkAllAreas() {
			if (this.all_areas) {
				let areas = []
				let selected_clients = this.user_clients.filter((e) => this.client.includes(e.id))
				selected_clients.forEach((client) => {
					client.client_areas.forEach((area) => {
						areas.push(area)
					})
				})
				this.area = this.areas.map((e) => e.value)
			} else {
				this.area = []
			}
		},

		getClientName(id) {
			let obj = this.user_clients.find((obj) => {
				return obj.id === id
			})
			if (obj) return obj.name
			else return ''
		},

		enableCustomClientCheck(client) {
			if (this.getClientName(client) === 'Chevrolet') this.current_client = 'chevrolet'
			else this.current_client = ''
		},
	},

	created() {
		this.user_clients.forEach((client) => {
			this.clients.push({
				value: client.id,
				label: client.name,
			})
		})
		this.id = this.$route.params.id
		if (this.$route.params.company_document) {
			setTimeout(() => {
				this.autoSelectHeadquarter(this.$route.params.company_document)
			}, 500)
		}
		this.company = this.$route.params.id_company ? this.$route.params.id_company : ''
		this.origin = this.$route.params.id_company ? 'headquarter' : 'branch'

		this.enableCustomClientCheck(this.id_user_client_selected)
		this.fetchLists()
		this.getCountryList()
	},

	validations() {
		return {
			name: { required, maxLength: maxLength(140) },
			fantasy: { maxLength: maxLength(140) },
			companies_label: { required },
			country: {
				requiredIf: requiredIf(() => {
					return this.addressRequired
				}),
			},
			address: {
				requiredIf: requiredIf(() => {
					return this.addressRequired
				}),
			},
			city: {
				requiredIf: requiredIf(() => {
					return this.addressRequired
				}),
			},
			state: {
				requiredIf: requiredIf(() => {
					return this.addressRequired
				}),
			},
			client: { required },
			area: {
				requiredIf: requiredIf(() => {
					return this.client ? true : false
				}),
			},
		}
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.file-url
    a
        text-decoration none
        color black
</style>
